import { useUTM } from '@repo/platform';
import { useToast } from '@zenterprise-inc/ui';
import { useMutation } from 'react-relay';

import { applyRefundMutation } from '@/__generated__/applyRefundMutation.graphql';
import { applyRefund as applyRefundQuery } from '@/graphql/mutation/taxRefund/applyRefund';

export const useApplyRefund = () => {
  const [commit, isInFlight] = useMutation<applyRefundMutation>(applyRefundQuery);
  const { utmData } = useUTM();
  const toast = useToast();

  const showErrorToast = (message?: string) => {
    toast({ content: message, icon: 'error', iconColor: 'red.600' });
  };

  const applyRefund = ({
    variables,
    onCompleted,
    onError
  }: {
    variables: {
      refundId: string;
      phoneNumber?: string;
      bank: string;
      accountOwner: string;
      accountNo: string;
      metaProperties?: string;
    };
    onCompleted: () => void;
    onError?: () => void;
  }) => {
    commit({
      variables: {
        ...utmData,
        ...variables,
        phoneNumber: variables.phoneNumber ?? ''
      },
      onCompleted: (response, error) => {
        const { result, errors: applyRefundError } = response?.applyRefund ?? {};
        if (error && error?.length > 0) {
          showErrorToast(error[0]?.message);
          return;
        }
        if (applyRefundError?.code) {
          showErrorToast('알 수 없는 에러가 발생했습니다.');
          return;
        }
        if (result) {
          onCompleted();
        }
      },
      onError: (error) => {
        if (onError) {
          onError();
          return;
        }

        if (error.message.includes('이미 신청된 사업체')) {
          showErrorToast('이미 신청된 사업체 입니다.');
        } else {
          showErrorToast(error.message);
        }
      }
    });
  };

  return {
    applyRefund,
    isInFlight
  };
};
